<template>

  <div>

    <section-background-image v-if="content.backgroundImage" :image="content.backgroundImage"></section-background-image>

    <div class="wrapper__inner--narrow">

  
      <section :class="pageCss">
        <div class="quote__content" v-html="content.quote"></div>
        <span class="quote__author" v-html="content.author"></span>
        <span class="quote__position" v-html="content.position"></span>
      </section>

    </div>

  </div>

</template>

<script>

  import SectionBackgroundImage from '@/components/Blocks/SectionBackgroundImage.vue';

  export default {
    name: 'SectionQuote',
    props: {
      content: {
        type: Object,
        required: true,
        default: () => {}
      }
    },
    computed: {
      pageCss() {
        return `content content__${this.content.type}`;
      }
    },
    components: {
      SectionBackgroundImage
    }
  };
</script>